import { render } from "./DatasetCreateModal.vue?vue&type=template&id=3d185956&scoped=true"
import script from "./DatasetCreateModal.vue?vue&type=script&lang=js"
export * from "./DatasetCreateModal.vue?vue&type=script&lang=js"

import "./DatasetCreateModal.vue?vue&type=style&index=0&id=3d185956&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d185956"]])

export default __exports__